// Strictly typed ResendOTPButton.tsx (browser-safe)
import React, { Component } from 'react'
import * as ReactBootstrap from 'react-bootstrap'

interface ResendOTPButtonProps {
  onRequestOTP: () => void
  onButtonStateChanged: (enabled: boolean) => void
}

interface ResendOTPButtonState {
  isButtonDisabled: boolean
  clickCount: number
  timer?: number
}

export class ResendOTPButton extends Component<ResendOTPButtonProps, ResendOTPButtonState> {
  private interval?: number

  constructor(props: ResendOTPButtonProps) {
    super(props)
    this.state = {
      isButtonDisabled: true,
      clickCount: 0,
    }
  }

  componentDidMount(): void {
    setTimeout(() => {
      this.setState({ isButtonDisabled: false }, () => {
        this.props.onButtonStateChanged(!this.state.isButtonDisabled)
      })
    }, 30000)
  }

  componentDidUpdate(): void {
    if (this.state.timer === 1 && this.interval !== undefined) {
      clearInterval(this.interval)
    }
  }

  componentWillUnmount(): void {
    if (this.interval !== undefined) {
      clearInterval(this.interval)
    }
  }

  resendOtp = (): void => {
    this.setState(
      prevState => ({
        isButtonDisabled: true,
        clickCount: prevState.clickCount + 1,
      }),
      () => {
        setTimeout(() => {
          if (this.state.clickCount < 2) {
            this.setState({ isButtonDisabled: false }, () => {
              this.props.onButtonStateChanged(!this.state.isButtonDisabled)
            })
          }
        }, 30000)

        this.interval = window.setInterval(() => {
          this.setState(prevState => ({ timer: (prevState.timer || 30) - 1 }))
        }, 1000)

        this.props.onRequestOTP()
      }
    )
  }

  render(): React.ReactNode {
    return (
      <ReactBootstrap.Button
        variant="link"
        className="float-left btn text-dark btn-sm"
        type="button"
        disabled={this.state.isButtonDisabled}
        onClick={this.resendOtp}
      >
        Resend OTP
      </ReactBootstrap.Button>
    )
  }
}
